import dayjs from "dayjs";
// 获取传入日期在一周出现得第几天
export function formatTime(t) {
    let date = new Date(t)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    return { year, month, day }
}

//计算传入得日期是一年得第几周
export function getWeek(dt) {
    let d1 = new Date(dt);
    let d2 = new Date(dt);
    d2.setMonth(0);
    d2.setDate(1);
    let rq = d1 - d2;
    let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
    let num = Math.ceil(days / 7);
    return num;
}
// 月日前面补0
export function
padZero(s) {
    return String(s).padStart(2, '0')
}

//获取指定月份的最后一天
export function getMonthFinalDay(year,month){
    var day='';
    if(year==null || year==undefined || year==''){
        year = new Date().getFullYear();
    }
    if(month==null ||  month==undefined || month==''){
        month = new Date().getMonth()+1;
    }
    day = new Date(new Date(year,month).setDate(0)).getDate();
    return year+"-"+padZero(month)+"-"+day;
     
}